import { useOffer } from "~/sdk/useOffer"
import type { Product } from "@decocms/apps-commerce/types"
import type { ExtendedProductItem } from "~/sdk/ga4/types/index"
import { variantFromAdditionalProperty } from "~/sdk/ga4/transform/itemVariant"

export function toProductItem(product: Product, extended: ExtendedProductItem) {
    const {
        name = '',
        offers,
        sku,
        brand: productBrand,
        inProductGroupWithID = '',
        url = '',
        category = '',
    } = product
    const brand = productBrand?.name ?? ''
    // `price` é o preço efetivo da etapa (vitrine/PDP/carrinho). O preço de
    // Pix/boleto/cartão (`getFinalPrice`) só vale na finalização (#285).
    const { listPrice = 0, price = 0, seller = '1' } = useOffer(offers)

    return {
        sku,
        inProductGroupWithID,
        name,
        seller,
        listPrice: listPrice,
        price,
        url,
        brand,
        category,
        // Nome da variação (ex. "Camomila"), não o nome do SKU — #284.
        variant: variantFromAdditionalProperty(product.additionalProperty),
        extended,
    }
}
